export const masonryMetaData = {
    isRepeatable: false
}
